import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Helmet } from "react-helmet";

interface Data {
  imageSrc: string;
  title: string;
  description: string;
  buttonLabel: string;
  buttonUrl: string;
}

const NotFound: React.FC = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const data: Data = {
    imageSrc: '/general/404.webp',
    title: "Oops! It looks like you're lost.",
    description:
      "The page you're looking for isn't available. Try to search again or use the go to.",
    buttonLabel: 'Go back to homepage',
    buttonUrl: '/',
  };

  return (
    <>
    <HelmetProvider>
        <Helmet>
          <title>Page Not Found | 404 Error | Halo Holidays</title>
          <meta name="description" content="Oops! The page you're looking for can't be found. Return to our homepage or contact us for assistance." />
        </Helmet>
    </HelmetProvider>
    <Header />
    <section className="py-40 container mx-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center space-y-8 lg:space-y-0">
          <div className="lg:w-1/3 md:ml-16">
            <img src={data.imageSrc} alt="404 illustration" />
          </div>
          <div className="lg:w-2/2">
            <div className="text-center lg:text-left">
              <div className="text-6xl font-bold">
                40<span className="text-halo-pink">4</span>
              </div>
              <h2 className="text-2xl font-semibold mt-4">{data.title}</h2>
              <p className="mt-4">{data.description}</p>
              <div className="mt-8">
                <Link to={data.buttonUrl}>
                  <a className="inline-block px-6 py-3 bg-halo-pink text-white text-md font-medium rounded-md hover:bg-pink-800">
                    {data.buttonLabel}
                  </a>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer />
    </>
  );
};

export default NotFound;
